import { getApiBaseUrl } from './api';
import { ensureOk } from './httpError';

export interface SupportManual {
  id: string;
  title: string;
  description: string;
  file_url: string;
  file_name: string;
  file_size: number;
  uploaded_by: string;
  is_visible: boolean;
  created_at: string;
}

function authHeaders(token: string) {
  return { Authorization: `Bearer ${token}` };
}

export async function listSupportManuals(token: string): Promise<SupportManual[]> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-manuals`, {
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Falha ao carregar manuais');
  const data = await res.json();
  return data.manuals ?? [];
}

export async function uploadSupportManual(
  token: string,
  file: File,
  title: string,
  description: string,
): Promise<SupportManual> {
  const form = new FormData();
  form.append('file', file);
  form.append('title', title);
  form.append('description', description);

  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-manuals`, {
    method: 'POST',
    headers: authHeaders(token),
    body: form,
  });
  await ensureOk(res, 'Falha ao fazer upload do manual');
  const data = await res.json();
  return data.manual;
}

export async function updateSupportManual(
  token: string,
  id: string,
  payload: { title?: string; description?: string },
): Promise<SupportManual> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-manuals/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  await ensureOk(res, 'Falha ao atualizar manual');
  const data = await res.json();
  return data.manual;
}

export async function toggleManualVisibility(token: string, id: string): Promise<SupportManual> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-manuals/${id}/visibility`, {
    method: 'PATCH',
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Falha ao alterar visibilidade');
  const data = await res.json();
  return data.manual;
}

export async function deleteSupportManual(token: string, id: string): Promise<void> {
  const res = await fetch(`${getApiBaseUrl()}/api/v1/support-manuals/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  if (!res.ok) throw new Error('Falha ao excluir manual');
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
